import React from 'react'

import { Text } from '@wartek-id/text'
import {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleIcon,
  CollapsibleContent,
} from '@wartek-id/collapsible'

import type { FAQItemProps } from '../../types/faq'

const FAQ1 = (props: FAQItemProps) => {
  return (
    <Collapsible {...props}>
      <CollapsibleTrigger className="!text-left">
        <Text variant="body-sm" className="!font-semibold">
          Apa itu Asesmen?
        </Text>
        <CollapsibleIcon></CollapsibleIcon>
      </CollapsibleTrigger>
      <CollapsibleContent className="p-4">
        <Text className="mb-6">
          Asesmen adalah proses pengumpulan dan pengolahan informasi untuk{' '}
          <b>
            mengetahui kebutuhan belajar, perkembangan, dan pencapaian hasil
            belajar peserta didik
          </b>
          , yang hasilnya kemudian digunakan sebagai bahan refleksi serta
          landasan untuk meningkatkan mutu pembelajaran.
        </Text>
      </CollapsibleContent>
    </Collapsible>
  )
}

export default FAQ1
